module.exports = __webpack_public_path__ + "static/media/Uniserved-Logo-square-for-dark-bg.cc2b67f9.png";